import ProgrammeHero from "../components/programme/ProgrammeHero";
import Curriculum from "../components/programme/Curriculum";
import AddOns from "../components/programme/AddOns";
import TwoPaths from "../components/programme/TwoPaths";
import QuestionsCta from "../components/programme/QuestionsCta";

export default function Programme() {
  return (
    <main data-testid="programme-page">
      <ProgrammeHero />
      <Curriculum />
      <AddOns />
      <TwoPaths />
      <QuestionsCta />
    </main>
  );
}
